<template>
  <div class="main" @click.self="$emit('close')">
    <div class="box-modal">
      <div class="title">

        <span>انتخاب کوین</span>

        <div class="search">
          <label>
            <inline-svg :src="require('../../../assets/icon/search.svg')"/>
            <input placeholder="جستجو در رمز ارزها" type="search" class="input-search">
          </label>
        </div>

      </div>

      <div v-for="(item , index) in coins" :key="index" @click="selectfunction(item)" class="coins">
        <img :src="require('@/assets/coins/' + item.code + '.png')" width="30"/>
        <div class="name-coin">
          <span>{{ item.persianName }}</span>
          <small>{{ item.code }}</small>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: "resive-otc-modal",

  data() {
    return {
      select: '',
      items: [
        {name: 'تومان', relationName:'TMN' , logo:'TOMAN'},
        {name:'تتر' , relationName:'USDT' , logo:'USDT'},
        {name: 'بیت کوین', relatedCoin: 'BTC', logo: 'BTC'},
        {name: 'دوج کوین', relatedCoin: 'DOGE', logo: 'DOGE'},
        {name: 'بایننس کوین', relatedCoin: 'BNB', logo: 'BNB'},
        {name: 'اتریوم', relatedCoin: 'ETH', logo: 'ETH'},
        {name: 'بیت کوین کش', relatedCoin: 'BCH', logo: 'BCH'},
        {name: 'استلار', relatedCoin: 'XLM', logo: 'XLM'},
        {name: 'ریپل', relatedCoin: 'XPR', logo: 'XPR'},
        {name: 'ترون', relatedCoin: 'TRON', logo: 'TRON'},
        {name: 'سلو', relatedCoin: 'CELO', logo: 'CELO'},
        {name: 'لایت کوین', relatedCoin: 'LTC', logo: 'LTC'},
        {name: 'ماتیک', relatedCoin: 'MATIC', logo: 'MATIC'},
        {name: 'تتر', relatedCoin: 'USDT', logo: 'USDT'},
      ],
      coins:[]
    }
  },

  methods: {
    async getCoins() {
      this.state.loading = true;
      const res = await this.$axios.get("/coins/details");
      this.coins = res.content.filter((name) => name.coin !== "TOMAN");
      this.state.loading = false;

    },
    selectfunction(e) {
      this.select = e;

      this.$emit('resivecoin', this.select)
    },



  },
  created() {
    this.getCoins();
  }
}
</script>

<style lang="scss" scoped>
.main {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgb(0, 0, 0, 0.7);
  z-index: 10;

  .box-modal {
    background-color: rgba(11, 20, 38, 1);
    display: flex;
    flex-direction: column;
    color: #FFFFFF;
    border-radius: 16px;
    padding: 28px;
    width: 367px;
    max-height: 450px;
    overflow: auto;
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */

    .title {
      position: sticky;
      top: 0;
      background-color: #0B1426;
    }

    .search {
      width: 100%;

      label {
        position: relative;
        width: 100%;
        display: flex;
        margin: 24px 0;

        svg {
          position: absolute;
          top: 30%;
          right: 20px;
        }

        .input-search {
          background-color: rgba(215, 200, 200, 0.12);
          color: #D7C8C8;
          font-size: 12px;
          height: 44px;
          width: 100%;
          padding-right: 50px;
        }
      }

    }

    .coins {
      display: flex;
      flex-direction: row;
      gap: 10px;
      height: 40px;
      align-items: center;
      margin-bottom: 10px;
      padding: 5px;
      cursor: pointer;

      &:hover {
        background-color: rgba(215, 200, 200, 0.12);;
      }

      .name-coin {
        display: flex;
        flex-direction: column;
        gap: 5px;
        width: 100px;
        text-align: right;
      }

      svg {
        width: 30px;
        height: 30px;
      }

      span {
        font-size: clamp(12px, 1vw, 16px);
        color: #FFFFFF;
      }

      small {
        color: rgba(215, 200, 200, 1);
      }
    }
  }
}
</style>